import { render, staticRenderFns } from "./PaymentInfo.vue?vue&type=template&id=05cdd651"
import script from "./PaymentInfo.vue?vue&type=script&lang=ts"
export * from "./PaymentInfo.vue?vue&type=script&lang=ts"
import style0 from "./PaymentInfo.vue?vue&type=style&index=0&id=05cdd651&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports